const OutputCard = ({ disabled, result }) => {
    return (
        <div className={"outputCard card" + (disabled ? " disabled" : "")}>
            Output: {result !== "" && <code className="output">{result.toString()}</code>} <br></br><br></br>
        </div>
    );
}

export default OutputCard;